<template>
  <el-scrollbar>
    <div class="table_layout" :class="{ 'no-bg': noBg }">
      <div class="tab" v-if="$slots.tab">
        <slot name="tab"></slot>
      </div>
      <div class="top" v-if="$slots.filter">
        <div v-if="title" class="title">
          <span>{{ title }}</span>
          <slot name="titleInner"></slot>
        </div>
        <div class="filter">
          <slot name="filter"></slot>
        </div>
      </div>
      <div class="center" v-if="$slots.center">
        <div class="operate_btn" v-if="cOptions?.length">
          <el-button v-for="{ label, vOn, disabled = false, ...args } in cOptions" :disabled="typeof disabled === 'boolean'
              ? disabled
              : disabled({ label, vOn, ...args })
            " :key="label" v-bind="args || {}" v-on="vOn || {}" :icon="iconMap[args.icon]">{{ label }}</el-button>
        </div>
        <div v-if="cTitle" class="title">
          <span>{{ cTitle }}</span>
          <slot name="cTitleInner"></slot>
        </div>
        <slot name="center"></slot>
      </div>
      <div class="bottom" :class="contentOverflowHidden ? 'bottom_overflow_hidden' : ''">
        <div class="operate_btn" v-if="options?.length">
          <el-button v-for="{ label, vOn, disabled = false, ...args } in options" :disabled="typeof disabled === 'boolean'
              ? disabled
              : disabled({ label, vOn, ...args })
            " :key="label" v-bind="args || {}" v-on="vOn || {}" :icon="iconMap[args.icon]">{{ label }}</el-button>
          <slot name="bottomOperate"></slot>
        </div>

        <div v-if="bTitle" class="title">
          <span>{{ bTitle }}</span>
          <slot name="bTitleInner"></slot>
        </div>
        <slot name="content"></slot>
      </div>
    </div>
  </el-scrollbar>
</template>
<script setup>
// import { Plus, Upload, Download } from "@element-plus/icons-vue";
import * as iconMap from "@element-plus/icons-vue";
import { computed } from "vue";
// 新增的图标可能需要
// const iconMap = computed(() => {
//   return {
//     Plus: Plus,
//     Upload: Upload,
//     Download: Download,
//   };
// });
const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  cTitle: {
    type: String,
    default: "",
  },
  bTitle: {
    type: String,
    default: "",
  },
  options: {
    type: Array,
    default() {
      return [];
    },
  },
  cOptions: {
    type: Array,
    default() {
      return [];
    },
  },
  noBg: {
    type: Boolean,
    default: false
  },
  contentOverflowHidden: {
    type: Boolean,
    default: false
  }
});
</script>
<style lang="scss" scoped>
$contentLeftRightPadding: 20px;

:deep(.el-scrollbar__view) {
  height: 100%;
}

.table_layout {
  height: 100%;
  box-sizing: border-box;
  padding: 0;
  display: flex;
  flex-direction: column;
  position: relative;
  .bottom_overflow_hidden{
    overflow: hidden;
  }
  .title {
    display: flex;
    align-items: center;
    font-weight: bold;
    margin-bottom: 10px;

    &::before {
      content: "";
      width: 3px;
      height: 14px;
      margin-right: 10px;
      background: #2259fd;
    }

    span {
      margin-right: 5px;
    }
  }

  .tab {
    background: #fff;
    padding: 0px $contentLeftRightPadding 0 $contentLeftRightPadding;
    margin-bottom: 10px;
  }

  .top {
    background: #fff;
    padding: 20px $contentLeftRightPadding 0 $contentLeftRightPadding;
    margin-bottom: 10px;
  }

  .center {
    background: #fff;
    padding: 20px $contentLeftRightPadding;
    margin-bottom: 10px;
  }

  .center,
  .bottom {
    .operate_btn {
      margin-bottom: 20px;
    }
  }

  .bottom {
    background: #fff;
    padding: 20px $contentLeftRightPadding;
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  &.no-bg {
    .bottom {
      background: transparent !important;
      backdrop-filter: none;
      padding: 0;
    }
  }

}
</style>
